import { NgTemplateOutlet } from '@angular/common';
import { Component, DestroyRef, inject, output } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { lucideBookOpen, lucidePencilRuler, lucideSquareArrowOutUpRight, lucideX } from '@ng-icons/lucide';
import { HlmButton } from '@spartan-ng/helm/button';

import { AideService } from './aide.service';
import { Aide } from './models/aide.model';

@Component({
  selector: 'app-aide',
  imports: [HlmButton, NgIcon, NgTemplateOutlet],
  templateUrl: './aide.component.html',
  providers: [provideIcons({ lucideX, lucideBookOpen, lucidePencilRuler, lucideSquareArrowOutUpRight })],
})
export class AideComponent {
  readonly #aideService = inject(AideService);
  readonly #router = inject(Router);
  readonly #destroy = inject(DestroyRef);
  onClose = output<void>();

  methodes: Aide[] = [];
  tutoriels: Aide[] = [];

  constructor() {
    var url = decodeURI(this.#router.url);
    var decoupeUrls = url.split('/');
    url = decoupeUrls[1] + '/' + decoupeUrls.pop();
    url = url.replace('#', '%23');
    this.#aideService
      .chercheParUrlFront(url)
      .pipe(takeUntilDestroyed(this.#destroy))
      .subscribe((result) => {
        this.methodes = result.items.filter((x) => x.estMethode);
        this.tutoriels = result.items.filter((x) => !x.estMethode);
      });
  }

  goToWiki(urlWiki: string) {
    window.open(urlWiki, '_blank');
  }

  closeAide(): void {
    this.onClose.emit();
  }
}
